import React from "react";

const Contact = () => {
  return (
    <section>
      <figure>
        <svg
          enableBackground="new 0 0 512 512"
          version="1.1"
          viewBox="0 0 512 512"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path d="m304.48 440.9c-1.86-1.86-4.43-2.93-7.07-2.93-2.63 0-5.21 1.07-7.07 2.93s-2.93 4.44-2.93 7.07 1.07 5.21 2.93 7.07 4.44 2.93 7.07 2.93c2.64 0 5.21-1.07 7.07-2.93s2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07z" />
          <path d="m256 93.024c-47.361 0-85.891 38.531-85.891 85.891v1.162c0 47.361 38.531 85.891 85.891 85.891h55.802c5.523 0 9.999-4.477 9.999-10s-4.477-10-10-10h-55.802c-36.332 0-65.891-29.559-65.891-65.891v-1.162c0-36.332 29.559-65.891 65.891-65.891s65.891 29.559 65.891 65.891v18.423c0 6.523-5.308 11.831-11.831 11.831s-11.831-5.308-11.831-11.831v-20.81c0-25.17-20.478-45.648-45.648-45.648-26.439 0-47.948 21.509-47.948 47.948s21.509 47.948 47.948 47.948h14.302c5.523 0 10-4.477 10-10s-4.477-10-10-10h-14.301c-15.41 0-27.948-12.538-27.948-27.948s12.537-27.948 27.948-27.948c14.142 0 25.648 11.505 25.648 25.648v20.81c0 17.552 14.279 31.831 31.831 31.831s31.831-14.279 31.831-31.831v-18.423c0-47.361-38.53-85.891-85.891-85.891z" />
          <path d="m461.07 370.99c-1.86-1.86-4.44-2.93-7.07-2.93s-5.21 1.07-7.07 2.93-2.93 4.44-2.93 7.07 1.07 5.21 2.93 7.07 4.44 2.93 7.07 2.93 5.21-1.07 7.07-2.93 2.93-4.44 2.93-7.07-1.07-5.21-2.93-7.07z" />
          <path d="m507.95 173.93l-221.3-163.72c-18.334-13.564-42.969-13.564-61.302 0l-221.3 163.72c-2.549 1.886-4.052 4.869-4.052 8.039v280c0 27.57 22.43 50 50 50h412c27.57 0 50-22.43 50-50v-280c0-3.17-1.503-6.153-4.052-8.039zm-270.7-147.65c11.218-8.3 26.293-8.3 37.511 0l211.97 156.82-158.25 158.25-14.429-14.429c-32.005-32.005-84.082-32.005-116.09 0l-14.429 14.429-158.25-158.25 211.97-156.82zm-200.26 461.61c-0.241 0.241-0.466 0.491-0.677 0.75-9.672-4.986-16.306-15.069-16.306-26.679v-255.86l149.38 149.38-132.4 132.4zm24.214 4.071l34-34h163.8c5.523 0 10-4.477 10-10s-4.477-10-10-10h-143.8l28-28h73.976c5.523 0 10-4.477 10-10s-4.477-10-10-10h-53.976l27.397-27.397 4e-3 -4e-3 4e-3 -4e-3 21.496-21.496c24.208-24.208 63.596-24.208 87.804 0l21.496 21.496c1e-3 1e-3 2e-3 3e-3 4e-3 4e-3s3e-3 3e-3 4e-3 4e-3l129.4 129.4h-389.61zm430.8-30c0 11.61-6.634 21.693-16.306 26.678-0.211-0.258-0.437-0.509-0.677-0.75l-132.4-132.4 101.38-101.38v83.027c0 5.523 4.477 10 10 10s10-4.477 10-10v-103.03l28-28v255.86z" />
        </svg>
      </figure>
      <div>
        <h4>Contact With Me</h4>
        <article>
          <p>
            <a href="mailto:ialy2dev@gmail.com">Email: ialy2dev@gmail.com</a>
          </p>
          <p>
            <a href="tel:+201153335808">Phone: +201153335808</a>
          </p>
          <p>
            <a target="_black" href="https://www.facebook.com/aly22i">
              Facebook
            </a>
          </p>
          <p>
            <a target="_black" href="https://github.com/iAli22">
              Github
            </a>
          </p>
        </article>
      </div>
    </section>
  );
};

export default Contact;
